import React, { useState,useRef } from "react";
import "./Navbar.css";
import { LuAlarmClock } from "react-icons/lu";
import { Link } from "react-router-dom";
import { LiaPhoneVolumeSolid } from "react-icons/lia";
import Form from 'react-bootstrap/Form';
import Modal from 'react-bootstrap/Modal';
import emailjs from 'emailjs-com';


const Navbar = () => {

   // bookappointment script 
  const form = useRef()
  const [data, updateData] = useState({
    Name: "",
    Email: '',
    Number: '',
    Subject: '',
    Message: ''
  })

  const { Name, Email, Number, Subject, Message } = data;

  const changeHandler = e => {
    updateData({ ...data, [e.target.name]: [e.target.value] })

  }
  const submitHandler = e => {
    e.preventDefault();

    emailjs.sendForm('service_d7nkc98', 'template_dhs0a87', e.target, '-_ajGXvF0DTOYDkQE')
      .then((result) => {
        alert("Successfully Booked Your Appointment ")
        updateData({
          Name: "",
          Email: "",
          Number: "",
          Subject: '',
          Message: ''

        })

      }, (error) => {
        console.log(error.text);
      });

  }

  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [showDropdown, setShowDropdown] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <>
      <nav className="navbar container-fluid custom-container" >
        <div className="top-strip">
          <div className="logo">
            <img src="logoSikar.png" alt="logo" />
          </div>

          <div className="right-items">
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <LuAlarmClock className="clock" />
              <div style={{ display: "flex", flexDirection: "column" }}>
                <span style={{ fontSize: "15px", fontWeight: "bold", color: 'rgb(115, 115, 115)' }}>
                  Mon–Sat (09am – 05pm)
                </span>
                <span style={{ fontSize: "15px", fontWeight: "bold", color: 'rgb(115, 115, 115)' }}>
                  Sunday (Closed)
                </span>
              </div>
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <LiaPhoneVolumeSolid className="clock" />
              <div style={{ display: "flex", flexDirection: "column" }}>
                <span style={{ fontSize: "14px", fontWeight: "bold", color: 'rgb(115, 115, 115)', marginBottom: '-9px' }}>
                  My Number
                </span>
                <span style={{ fontSize: "30px", fontWeight: "bold", color: '#ff8a00' }}>
                  7382513158
                </span>
              </div>
            </div>
          </div>
        </div>

        <div className="nav-container">

          <ul className="menu">
            <li><a className="link_tags" href="/Home">HOME</a></li>
            <li><a className="link_tags" href="/about">ABOUT</a></li>


            <li
              className="services"
              onMouseEnter={() => setShowDropdown(true)}
              onMouseLeave={() => setShowDropdown(false)}
            >
              OUR SERVICES ▾
              {showDropdown && (
                <div className="mega-menu">
                  <div className="mega-content">

                    <div className="column">
                      <p><a className="link_tags" href="/Robotic_Joint_Replacement_by_dr_garlapati_sivasrikar_guntur">Robotic Joint Replacement</a></p>
                      <p><a className="link_tags" href="/Simple_and_Complex_Primary_Total_Knee_Replacement_by_dr_garlapati_sivasrikar_guntur">Simple & Complex Primary Total Knee Replacement</a></p>
                      <p><a className="link_tags" href="/TKR_in_Severe_Deformity_and_Bone_Loss_by_dr_garlapati_sivasrikar">TKR in Severe Deformity & Bone Loss</a></p>
                      <p><a className="link_tags" href="/Revision_Total_Knee_Replacement_by_dr_garlapati_sivasrikar_guntur">Revision Total Knee Replacement(TKR)</a></p>
                      <p><a className="link_tags" href="/General_Ortho_by_dr_garlapati_sivasrikar_guntur">General Orthopedics</a></p>

                    </div>

                    <div className="column">
                      <p><a className="link_tags" href="/Unicompartmental_Knee_Replacement_by_dr_garlapati_sivasrikar_guntur">Unicompartmental Knee Replacement</a></p>
                      <p><a className="link_tags" href="/Arthroscopy_Key_Hole_Surgery_by_dr_garlapati_sivasrikar_guntur">Arthroscopy (Key Hole Surgery)</a></p>
                      <p><a className="link_tags" href="/Spine_Surgery_by_dr_garlapati_sivasrikar_guntur">Spine Surgery</a></p>
                      <p><a className="link_tags" href="/Fracture_Management_by_drgarlapati_sivasrikar_guntur">Fracture Management</a></p>
                      <p><a className="link_tags" href="/Total_Hip_Replacement_by_dr_garlapati_sivasrikar_guntur">Total Hip Replacement</a></p>

                    </div>

                    <div className="column">
                      <p><a className="link_tags" href="/Ligament_Repairs_in_Knee_and_Shoulder_Sports_Injuries_by_dr_garlapati_sivasrikar_gutur">Ligament Repairs in Knee & Shoulder (Sports Injuries)</a></p>
                      <p><a className="link_tags" href="/Polytrauma_Treatment_by_garlapati_siva_srikar_guntur">Polytrauma</a></p>
                      <p><a className="link_tags" href="/Fast_Track_Knee_Replacement_by_dr_garlapati_siva_srikar">Fast-Track Knee Replacement</a></p>
                      <p><a className="link_tags" href="/Therapy_Free_Total_Knee_Replacement_by_dr_garlapti_siva_srikar_guntur">Therapy-Free Total Knee Replacement</a></p>

                    </div>



                  </div>
                </div>
              )}
            </li>
            <li><a className="link_tags" href="/about">TESTMONIALS</a></li>
            <li><a className="link_tags" href="/Doctors_Gallery">GALLERY</a></li>
            <li><a className="link_tags" href="/Home">BLOG</a></li>
            <li><a className="link_tags" href="/Contact">CONTACT</a></li>
          </ul>

          <button className="btn" onClick={handleShow} >BOOK APPOINTMENT</button>
        </div>
      </nav>

      {/* // mobile view */}
      <nav className="mobile mt-3" >
        <div className="top-strip">
          <span>Mon–Sat (09am – 05pm)</span>
          <span className="phone">📞 7382513158</span>
        </div>
        <div className="nav-container d-flex top-strip">
          <div className="logo d-flex mobile-logo ">
            <img src="logoSikar.png" alt="logo" />
            <span className="hamburger " onClick={() => setMenuOpen(!menuOpen)} style={{ color: '#0899ff' }}>
              ☰
            </span>
          </div>



          <ul className={`menu ${menuOpen ? "active" : ""}`}>
            <li><a className="link_tags" href="/Home">HOME</a></li>
            <li><a className="link_tags" href="/about">ABOUT</a></li>
            <li
              className="services"
              onClick={() => setShowDropdown(!showDropdown)}
            >
              OUR SERVICES ▾
              {showDropdown && (
                <div className="mega-menu">
                  <div className="mega-content">

                    <div className="column">
                      <p><a className="link_tags" href="/Robotic_Joint_Replacement_by_dr_garlapati_sivasrikar_guntur">Robotic Joint Replacement</a></p>
                      <p><a className="link_tags" href="/Simple_and_Complex_Primary_Total_Knee_Replacement_by_dr_garlapati_sivasrikar_guntur">Simple & Complex Primary Total Knee Replacement</a></p>
                      <p><a className="link_tags" href="/TKR_in_Severe_Deformity_and_Bone_Loss_by_dr_garlapati_sivasrikar">TKR in Severe Deformity & Bone Loss</a></p>
                      <p><a className="link_tags" href="/Revision_Total_Knee_Replacement_by_dr_garlapati_sivasrikar_guntur">Revision Total Knee Replacement(TKR)</a></p>
                      <p><a className="link_tags" href="/General_Ortho_by_dr_garlapati_sivasrikar_guntur">Revision Total Knee Replacement(TKR)</a></p>

                    </div>

                    <div className="column">
                      <p><a className="link_tags" href="/Unicompartmental_Knee_Replacement_by_dr_garlapati_sivasrikar_guntur">Unicompartmental Knee Replacement</a></p>
                      <p><a className="link_tags" href="/Arthroscopy_Key_Hole_Surgery_by_dr_garlapati_sivasrikar_guntur">Arthroscopy (Key Hole Surgery)</a></p>
                      <p><a className="link_tags" href="/Spine_Surgery_by_dr_garlapati_sivasrikar_guntur">Spine Surgery</a></p>
                      <p><a className="link_tags" href="/Fracture_Management_by_drgarlapati_sivasrikar_guntur">Fracture Management</a></p>
                      <p><a className="link_tags" href="/Total_Hip_Replacement_by_dr_garlapati_sivasrikar_guntur">Total Hip Replacement</a></p>
                    </div>

                    <div className="column">
                      <p><a className="link_tags" href="/Ligament_Repairs_in_Knee_and_Shoulder_Sports_Injuries_by_dr_garlapati_sivasrikar_gutur">Ligament Repairs in Knee & Shoulder (Sports Injuries)</a></p>
                      <p><a className="link_tags" href="/Polytrauma_Treatment_by_garlapati_siva_srikar_guntur">Polytrauma</a></p>
                      <p><a className="link_tags" href="/Fast_Track_Knee_Replacement_by_dr_garlapati_siva_srikar">Fast-Track Knee Replacement</a></p>
                      <p><a className="link_tags" href="/Therapy_Free_Total_Knee_Replacement_by_dr_garlapti_siva_srikar_guntur">Therapy-Free Total Knee Replacement</a></p>
                    </div>
                  </div>
                </div>
              )}
            </li>
            <li><a className="link_tags" href="/Gallery">GALLERY</a></li>
            <li><a className="link_tags" href="/about">PATIENT EDUCATION</a></li>
            <li><a className="link_tags" href="/about">BLOG</a></li>
            <li><a className="link_tags" href="/Contact">CONTACT</a></li>
            <button className="btn" onClick={handleShow} >BOOK APPOINTMENT</button>
          </ul>


        </div>
      </nav>

        <Modal style={{ marginTop: '50px' }} show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title className='text-center' style={{ color: '#0899ff', textAlign: 'center' }}>Book An Appointment</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form ref={form} onSubmit={submitHandler}>
            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
              <input type="text" value={Name} onChange={changeHandler} className="form-control" placeholder="Your Name" name="Name" required="Username is Required..." message="Username must be atmost 30 characters long..." style={{ padding: '10px' }} />
              <div className="help-block with-errors"></div>
            </Form.Group>

            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
              <input type="email" value={Email} onChange={changeHandler} className="form-control" placeholder="Your Email Address" name="Email" id="email" required="Email is required" data-error="Please enter your email" fdprocessedid="p2hd6j" style={{ padding: '10px' }} />
              <div className="help-block with-errors"></div>
            </Form.Group>

            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
              <input type="text" value={Number} onChange={changeHandler} className="form-control" name="Number" placeholder="Phone Number" id="phone_number" required="Number is Required" data-error="Please enter your number" fdprocessedid="cf7ig" style={{ padding: '10px' }} />
              <div className="help-block with-errors"></div>
            </Form.Group>

            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
              <input type="text" value={Subject} onChange={changeHandler} className="form-control" name="Subject" placeholder="Subject" id="msg_subject" required="Subject is Required" data-error="Please enter your subject" fdprocessedid="4mor3e" style={{ padding: '10px' }} />
              <div className="help-block with-errors"></div>
            </Form.Group>

            <Form.Group
              className="mb-3"
              controlId="exampleForm.ControlTextarea1"
            >

              <textarea name="Message" value={Message} onChange={changeHandler} className="form-control" id="message" cols="30" rows="3" placeholder="Type Your Message Here" required="Message is required" data-error="Write your message"></textarea>
              <div className="help-block with-errors"></div>
            </Form.Group>
            <button type="submit" className="btn " name="contact" style={{ backgroundColor: "#ff8a00", color: "whitesmoke" }} >Send Message</button>
            <div id="msgSubmit" className="h3 text-center hidden"></div>
            <div className="clearfix"></div>
          </Form>
        </Modal.Body>

      </Modal>
    </>
  );
};

export default Navbar;